import {useContext} from 'react';
import {FormState} from '../context';

const useIsCg719s = () => {
    const {node} = useContext(FormState);
    return node === 'cg719s' || node === 'generate_cg719s';
};

export default useIsCg719s;
